import { OkVal } from '@core/model/framework/Result/OkResult';
import { Option } from '@core/model/framework/Result/Option';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import { ConnectionFormItemDto } from '@core/service/digital-factory/bank/types/dto/connectionFormDto';

export type GetWebauthUrlInput = {
  userToken: string;
  bankId: string;
  form: Option<ConnectionFormItemDto[]>;
  tagging: string | undefined;
};
export type GetWebauthUrlOutput = Promise<OkVal<string>>;

@injectable()
export class GetWebauthUrl implements Usecase<GetWebauthUrlInput, GetWebauthUrlOutput> {
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}

  async execute(input: GetWebauthUrlInput): GetWebauthUrlOutput {
    return this.bankService.getWebauthUrl(input);
  }
}
